import { Amplify } from 'aws-amplify'

// Validate required environment variables
const requiredEnvVars = {
  VITE_AWS_REGION: import.meta.env.VITE_AWS_REGION,
  VITE_USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
  VITE_USER_POOL_CLIENT_ID: import.meta.env.VITE_USER_POOL_CLIENT_ID,
  VITE_OAUTH_DOMAIN: import.meta.env.VITE_OAUTH_DOMAIN,
  VITE_REDIRECT_SIGN_IN: import.meta.env.VITE_REDIRECT_SIGN_IN,
  VITE_REDIRECT_SIGN_OUT: import.meta.env.VITE_REDIRECT_SIGN_OUT,
  VITE_API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT,
}

// Check for missing environment variables
const missingVars = Object.entries(requiredEnvVars)
  .filter(([_, value]) => !value)
  .map(([key]) => key)

if (missingVars.length > 0) {
  throw new Error(
    `Missing required environment variables: ${missingVars.join(', ')}\n` +
    'Please ensure frontend/.env file is properly configured.'
  )
}

const awsConfig = {
  Auth: {
    Cognito: {
      region: import.meta.env.VITE_AWS_REGION,
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_OAUTH_DOMAIN,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [import.meta.env.VITE_REDIRECT_SIGN_IN],
          redirectSignOut: [import.meta.env.VITE_REDIRECT_SIGN_OUT],
          responseType: 'code' as const
        },
        email: true,
        username: false
      }
    }
  },
  API: {
    REST: {
      LiveMapsAPI: {
        endpoint: import.meta.env.VITE_API_ENDPOINT,
        region: import.meta.env.VITE_AWS_REGION
      }
    }
  }
}

Amplify.configure(awsConfig)

export default awsConfig